import React from "react"
import axios from "axios";
import { latest as API_URL, lastest_insecure as API_URL_INSECURE } from "../config/api";
import { Popconfirm, Icon, Drawer, Button, Switch, Collapse, Steps, Row, Col, Radio, message, Tag} from 'antd';
import {  panels } from "../config/Helpers";

const postUrlWidgets = API_URL + "reports";
const postUrlReportsInsecure = API_URL_INSECURE + "reports";

class ExportReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            visible: false,
            panels_status : {},
            panels : panels()
        }
    }
    defaultValues(){
        let self = this,
        panels = this.state.panels
        Object.keys(panels).map(function(index){
            let _dash = panels[index].dashboards,
            _dashboards = {},
            key_panel = panels[index].value; 
            Object.keys(_dash).map(function(index_aux){
                _dashboards[_dash[index_aux].value] = false
            });
            self.state.panels_status[key_panel] = _dashboards
        })

        return {
            current: 0,
            visible: false
        };
    }
    componentWillMount(){
        let self = this,
        panels = this.state.panels
        Object.keys(panels).map(function(index){
            let _dash = panels[index].dashboards,
            _dashboards = {},
            key_panel = panels[index].value; 
            Object.keys(_dash).map(function(index_aux){
                _dashboards[_dash[index_aux].value] = false
            });
            self.state.panels_status[key_panel] = _dashboards
        })
    }
    next() {
        let _is_validate = false, panels_status = this.state.panels_status;
        
        Object.keys(panels_status).map(function(index){
            let _dash = panels_status[index]
            Object.keys(_dash).map(function(index_aux){
                if(_dash[index_aux]){
                    _is_validate = true
                }
            });
        })
        if(_is_validate){
            const current = this.state.current + 1;
            this.setState({ current });
        }else{
            message.info('SELECT AT LEAST ONE DASHBOARD TO BE ABLE TO CONTINUE WITH EXPORT', 5);
        }
    }
    
    prev() {
        const current = this.state.current - 1;
        this.setState({ current });
    }
    showDrawer = () => {
        this.setState({
          visible: true,
        });
    };
    
    onClose = () => {
        this.setState(this.defaultValues());
    };
    activateDashboard = (panel, dashboard, checked) => {
       this.state.panels_status[panel][dashboard] = checked;
       this.forceUpdate();
    }
    generateReport(){
        let self = this;
        let qs = require("qs"),
        params = {};
        if(self.props.app.state._is_invited === true){
            params = { 
                _id_report : self.props.app.state.report_context._id,
                _email : self.props.app.state.mode_report._email,
                _dashboards : self.state.panels_status
            }
        }else{
            params = { 
                _id_report : self.props.app.state.report_context._id,
                _email : localStorage.getItem('email'),
                _dashboards : self.state.panels_status,
                api_token: localStorage.getItem("api_token")
            }
        }
        axios({
            method : 'post',
            url : (self.props.app.state._is_invited === true ? (postUrlReportsInsecure + "/export") : (postUrlWidgets + "/export")),
            data :  qs.stringify(params)
        }).then(function (response){
            message.info('We have sent a message to your email with the download link');
            self.onClose()
        })
    }
    getCountDashboards(key){
        let current_panels = this.state.panels_status[key], _count = 0;

        Object.keys(current_panels).map(function(index){
            if(current_panels[index]){
                _count++
            }
        })
        return _count
    }
    
    render = () => {
        
        let self = this,
        Panel = Collapse.Panel,
        panels_props = this.state.panels;
        let content_dashboards = Object.keys(panels_props).map(function(key){
            let panel_include = false, 
            panel_dashboards = self.props.app.state.mode_report._dashboards_select,
            key_panel = panels_props[key].value;
            if(self.props.app.state.mode_report._is_invited === true || self.props.app.state.mode_report._is_share === true){
                Object.keys(panel_dashboards).map((key_aux, index_aux) => {
                    let _decode = JSON.parse(panel_dashboards[key_aux])
                    if(_decode.panel === panels_props[key].value){
                        panel_include = true
                    }
                })
            }else{
                panel_include = true;
            }
            if(panel_include === true){   
                if(panels_props[key].value !== "parity" && 
                    panels_props[key].value !== "website" && 
                    panels_props[key].value !== "demographic" && 
                    panels_props[key].value !== "panel-gallery"){
                    return (
                        <Panel header={panels_props[key].name + `(${self.getCountDashboards(key_panel)})`} key={panels_props[key].value}>
                        
                            <table className="dashboard-report">
                                <tbody>
                                {
                                    Object.keys(panels_props[key].dashboards).map(function(key_dashboard){
                                        let dashboard_include = false
                                        if(self.props.app.state.mode_report._is_invited === true || self.props.app.state.mode_report._is_share === true){
                                            Object.keys(panel_dashboards).map((key_aux) => {
                                                let _decode = JSON.parse(panel_dashboards[key_aux]);
                                                if(_decode._dashboard === panels_props[key].dashboards[key_dashboard].value){
                                                    dashboard_include = true
                                                }
                                            })
                                        }else{
                                            dashboard_include = true
                                        }
                                        if(dashboard_include === true){
                                            const _is_disabled = (panels_props[key].dashboards[key_dashboard].value === "future_reserves" || 
                                                panels_props[key].dashboards[key_dashboard].value === "advance_booking" ||
                                                panels_props[key].dashboards[key_dashboard].value === "general_occupancy") ? true : false;

                                            return (
                                                <tr>
                                                    <td>
                                                        <span>
                                                            {panels_props[key].dashboards[key_dashboard].name}
                                                            {(_is_disabled === true) ? 
                                                                (<Tag style={{ 
                                                                    background: '#fff', 
                                                                    borderStyle: 'dashed', 
                                                                    marginLeft : 10,
                                                                    fontStyle : 'italic' }}>NEXT UPDATE</Tag>) : ''}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <Switch
                                                            checkedChildren={<Icon type="check" />} 
                                                            unCheckedChildren={<Icon type="close" />}
                                                            checked={self.state.panels_status[key_panel][panels_props[key].dashboards[key_dashboard].value]} 
                                                            onChange={self.activateDashboard.bind(self, key_panel, panels_props[key].dashboards[key_dashboard].value)}
                                                            disabled={_is_disabled} 
                                                            /> 
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    })
                                }
                                </tbody>                    
                            </table>
                        </Panel>
                    )
                }
            }
        })
        const content_download = (
            <div className="step-download">
                <Radio.Group defaultValue="a" buttonStyle="solid">
                    <Radio value="a"><Icon type="file-excel" style={{ fontSize : 14 }}/> EXCEL</Radio>
                    <Radio value="b" disabled="true"><Icon type="file-pdf" style={{ fontSize : 14 }} /> PDF</Radio>
                </Radio.Group>
                <div className="btn-download">
                    <p style={{
                        color : '#a2a2a2',
                        marginTop : 20,
                        marginBottom : 0,
                        fontStyle : 'italic'
                    }}>NOTE: THE REPORT WILL BE GENERATED AND SENT TO YOUR EMAIL.</p>
                    <Button type="default" icon="left" style={{marginRight : 15, letterSpacing : 1}} onClick={self.prev.bind(this)}>BACK</Button>
                    <Button type="primary" icon="download" style={{marginRight : 15, letterSpacing : 1}} onClick={this.generateReport.bind(this)}>SEND</Button>
                </div>
            </div>
        )
        const Step = Steps.Step;

        const steps = [{
                title: 'CHOOSE DASHBOARDS',
                content: (
                    <div>
                        <Collapse accordion>
                            {content_dashboards}
                        </Collapse>
                        <Popconfirm placement="bottom" title="Are you sure to cancel exportation？" icon={<Icon type="question-circle-o" style={{ color: 'red' }} />} onConfirm={self.onClose.bind(this)}>
                            <Button type="danger" className="next-step" style={{marginRight : 15}}>
                                CANCEL <Icon type="close" />
                            </Button>
                        </Popconfirm>
                        <Button type="primary" className="next-step" onClick={self.next.bind(this)}>
                            NEXT <Icon type="right" />
                        </Button>
                    </div>
                ),
            }, {
                title: 'CHOOSE FORMAT',
                content: content_download
            }
        ];
        return(
            <Drawer
                title="EXPORT REPORT"
                placement="left"
                closable={false}
                onClose={this.onClose}
                visible={this.state.visible}
                maskClosable={false}
                className="accordion-download-report" 
                width={'100%'}>
                    <Row>
                        <Col span={12} offset={6}>
                            <Steps current={this.state.current}>
                                {steps.map(item => <Step key={item.title} title={item.title} />)}
                            </Steps>
                            <div className="steps-content">{steps[this.state.current].content}</div>
                        </Col>
                    </Row>                        
            </Drawer>
        )
    }
}

export default ExportReport;


// WEBPACK FOOTER //
// ./src/Frontend/reports/ExportReport.js